


































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { XInput, XButton, XTextarea, Datetime, Keyboard } from '@lx-frontend/cvux'
import TraceRecord from './components/TraceRecord.vue'
import TipDialog from './components/TipDialog.vue'
import UploadImg from './components/UploadImg.vue'
import util from '../../common/util'

interface IParams {
  plate_number: string
  leave_time: string
  reason: {
    desc: string,
    images: string[]
  }
}

// 缓存一份车牌副本【主要是默认带出省别名与第一位车牌字母】
let plateObjCopy = {
  province: '',
  plate: ''
}

@Component({
  components: {
    XInput,
    XButton,
    XTextarea,
    Datetime,
    Keyboard,
    TraceRecord,
    TipDialog,
    UploadImg
  }
})
export default class Index extends Vue {
  leaveInfo = {}
  showAlphanumeric: boolean = false
  showProvinces: boolean = false

  plateObj = {
    province: '', // 省份
    plate: ''
  }

  imageList: string[] = []

  leaveTime: string = ''
  leaveTimeCopy: string = ''

  leaveDesc: string = ''

  endDate: string = util.formatTime(new Date(), 'yyyy-MM-dd')

  showTipDialog: boolean = false
  dialogTip: string = ''

  canSubmit: boolean = true // 防重复提交

  created() {
    this.getInitPlate()
  }

  async getInitPlate() {
    const { code, data } = await this.$rest.store.getStoreInfo()
    if (code === 0) {
      const plateArr = data.plate_prefix_code ? data.plate_prefix_code.split('') : ['粤']
      const plateRes = {
        province: plateArr[0],
        plate: plateArr[1] || ''
      }
      this.plateObj = plateRes
      plateObjCopy = JSON.parse(JSON.stringify(plateRes))
    }
  }

  async getCarVisitInfo(plate_number: string) {
    const { code, data, message } = await this.$rest.leaveStore.getCarVisitInfo({ plate_number })
    if (code !== 0) {
      this.dialogTip = message
      this.handleReset()
      this.showTipDialog = true
      return
    }
    this.leaveInfo = data
  }

  handleFocus() {
    (document.activeElement as HTMLInputElement).blur()
    this.showAlphanumeric = true
  }

  selectPlate() {
    this.showAlphanumeric = false
    this.showProvinces = true
  }

  handleProvince(value: string) {
    this.plateObj.province = value
    this.handleFocus()
  }

  handleAlphanumericValue(value: string) {
    if (this.plateObj.plate.length < 7) {
      this.plateObj.plate += value
    }
  }

  handleDelete(value: string) {
    this.plateObj.plate = this.plateObj.plate.substring(0, this.plateObj.plate.length - 1)
  }

  onLeaveTimeInput(val: string) {
    const value = new Date(val).getTime()
    const now = new Date().getTime()
    if (value > now) {
      this.showToast('离店时间不能超过当前时间')
      this.$nextTick(() => {
        this.leaveTime = this.leaveTimeCopy
      })
    } else {
      this.leaveTimeCopy = val
    }
  }

  handleDeleteImg(index: number) {
    this.imageList.splice(index, 1)
  }

  handleAddImg(localIds: string[]) {
    this.imageList = this.imageList.concat(localIds)
  }

  async handleComfirm() {
    if (!this.leaveDesc) {
      this.showToast('请填写放行备注')
      return
    }
    if (!this.imageList.length) {
      this.showToast('请至少上传一张包含完整车牌号的照片')
      return
    }

    // 防重复提交
    if (!this.canSubmit) return
    this.canSubmit = false

    const { province, plate } = this.plateObj
    const plate_number = `${province}${plate}`
    const params = {
      plate_number,
      leave_time: this.leaveTime,
      reason: {
        desc: this.leaveDesc,
        images: []
      }
    }

    this.switchLoading({ status: true, text: '加载中...' })

    // 上传图片
    // 1、先传微信
    const mediaIds = await Promise.all(this.imageList.map((localId) => {
      return new Promise((resolve) => {
        this.$wechat.wx.uploadImage({
          isShowProgressTips: 0,
          localId,
          success: (res: any) => resolve(res.serverId),
          fail: () => {
            this.switchLoading({ status: false })
            this.showToast('图片上传失败，请稍后重试')
            this.canSubmit = true
          }
        })
      })
    }))
    // 2、再传后端，拿到图片绝对地址
    const { code, data, message } = await this.$rest.wx.getLeaveStoreImage({ media_ids: mediaIds })
    if (code !== 0) {
      this.canSubmit = true
      this.switchLoading({ status: false })
      this.showToast(message)
      return
    }

    // 拼接上图片绝对地址
    params.reason.images = data.map((item: any) => item.upload_image)

    // 提交表单
    this.submit(params)
  }

  async submit(params: IParams) {
    const { code, message } = await this.$rest.leaveStore.postCarVisitRegister(params)

    this.switchLoading({ status: false })
    this.canSubmit = true

    if (code !== 0) {
      this.showToast(message)
      return
    }
    this.handleReset()
    this.plateObj = JSON.parse(JSON.stringify(plateObjCopy))
    this.showToast('离店登记成功')
  }

  handleDialogConfirm() {
    this.dialogTip = ''
    this.showTipDialog = false
  }

  handleReset() {
    this.leaveInfo = {}
    this.leaveDesc = ''
    this.imageList = []
  }

  @Watch('showAlphanumeric')
  watchAlphanumeric(newVal: boolean) {
    if (newVal) return
    // 车牌键盘收起，触发查询
    const { province, plate } = this.plateObj
    const plate_number = `${province}${plate}`
    if (!util.regexpMap.car_plate_number.test(plate_number)) {
      this.showToast('车牌号格式错误')
      this.handleReset()
      return
    }

    const currentTime = util.formatTime(new Date(), 'yyyy-MM-dd hh:mm')
    this.leaveTime = currentTime
    this.leaveTimeCopy = currentTime

    this.getCarVisitInfo(plate_number)
  }
}
